import React from "react";
import Autocomplete from '@mui/lab/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "./ConfirmCancelDialog";
import { LanguageContext } from './LanguageContext';

const defaultToolbarStyles = {
    iconButton: {
    },
};

class AdminToiminnotAdd extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RiviAvain: null,
            AsiakasAvain: null,
            ToimintoId: null,
            Entiteetti_Id: null,
            Toiminto: null,
            Oikeustaso: null,
            Aktivoitu: 1,
            Created: null,
            Updated: null,
            Username: null,
            Active: null,
            entiteetit: (Object.keys(props.lookupLists.entiteetit).map(function (d) { return { value: d, label: props.lookupLists.entiteetit[d] }; }) || []),
        };
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            RiviAvain: null,
            AsiakasAvain: null,
            ToimintoId: null,
            Entiteetti_Id: null,
            Toiminto: null,
            Oikeustaso: null,
            Aktivoitu: 1,
            Created: null,
            Updated: null,
            Username: null,
            Active: null
        });
    }

    handleSave = () => {
        this.props.onAddNewRow({
            RiviAvain: 1, //dummy-arvo
            AsiakasAvain: 1, //dummy-arvo
            ToimintoId: 1, //dummy-arvo
            Entiteetti_Id: this.state.Entiteetti_Id,
            Toiminto: this.state.Toiminto,
            Oikeustaso: this.state.Oikeustaso,
            Aktivoitu: this.state.Aktivoitu,
            Created: this.state.Created,
            Updated: this.state.Updated,
            Username: this.state.Username,
            Active: this.state.Active
        });

        this.handleClearData();
    };

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({
                [item]: newValue.value
            })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true });
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { entiteetit } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.NewRow}>
                    <IconButton onClick={this.handleClickOpen}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={this.state.open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.AdminToiminnot.Title}</DialogTitle>

                    <DialogContent style={{ width: "500px" }}>
                        <Autocomplete
                            onChange={(event, newValue) => this.handleListChange(event, newValue, 'Entiteetti_Id')}
                            options={entiteetit}
                            getOptionLabel={(option) => option.label}
                            style={{ width: 400 }}
                            renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.AdminToiminnot.Columns[1]} />}
                        />
                        <TextField
                            margin="dense"
                            id="Toiminto"
                            label={dictionary.AdminToiminnot.Columns[2]}
                            type="text"
                            style={{ width: 400 }}
                            value={this.state.Toiminto || ""}
                            onChange={this.handleChange('Toiminto')}
                        />
                        <TextField
                            margin="dense"
                            id="Oikeustaso"
                            label={dictionary.AdminToiminnot.Columns[3]}
                            type="text"
                            style={{ width: 400 }}
                            value={this.state.Oikeustaso || ""}
                            onChange={this.handleChange('Oikeustaso')}
                        />
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "AdminToiminnotAdd" })(AdminToiminnotAdd);
